import { IconKeys } from "dash-ui";
import { RoutesPath } from "flow-components/routes/routes";

export const sidebarItemsList: {
  label: string;
  icon?: IconKeys;
  disabled?: boolean;
  path: string;
}[] = [
  {
    label: "properties",
    icon: "home",
    path: RoutesPath.Properties,
  },
  {
    label: "organizations",
    icon: "suitcase",
    path: RoutesPath.Organizations,
  },
  {
    label: "marketAreas",
    icon: "mapMarker",
    path: RoutesPath.MarketAreas,
  },
  {
    label: "amenities",
    icon: "checklist",
    path: RoutesPath.Amenities,
  },
  {
    label: "externalSales",
    icon: "chart",
    path: RoutesPath.ExternalSales,
  },
  {
    label: "brokers",
    icon: "artboard",
    path: RoutesPath.Brokers,
  },
  {
    label: "seekers",
    icon: "account",
    path: RoutesPath.Seekers,
  },
  {
    label: "management",
    icon: "setting2",
    path: RoutesPath.Management,
  },
  {
    label: "apiManagement",
    icon: "world",
    path: RoutesPath.APIManagement,
  },
];
